import "core-js/modules/es.array.push.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "custom-upload-file"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 1,
  class: "upload-file-preview"
};
const _hoisted_4 = ["src", "type"];
const _hoisted_5 = {
  class: "el-upload-list__item-actions"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "file-type-tag"
};
const _hoisted_9 = {
  style: {
    "color": "red",
    "margin-top": "10px"
  }
};
import { ref, computed, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { Plus, ZoomIn, Delete } from '@element-plus/icons-vue';
import { useStore } from '@/store/index';
import { fileUpload } from '@/utils/upload';
export default {
  __name: 'ImageUploaderDialog',
  props: {
    modalVisible: Boolean,
    currentRow: Object,
    fileList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modalVisible', 'submit'],
  setup(__props, {
    emit: __emit
  }) {
    const store = useStore();
    const props = __props;
    const internalFileList = ref([]);
    const imageList = ref([]);
    const showUploadButton = ref(true);
    const sumbitShow = ref(false);
    const {
      proxy
    } = getCurrentInstance();
    const emit = __emit;
    const dialogVisible = computed({
      get: () => props.modalVisible,
      set: value => emit('update:modalVisible', value)
    });
    watch(() => props.fileList, newVal => {
      if (newVal && newVal.length) {
        internalFileList.value = newVal.map(item => ({
          uid: item.uid || Date.now() + Math.random(),
          name: item.url.split('/').pop(),
          status: 'success',
          url: item.url,
          type: item.type || getFileTypeFromUrl(item.url)
        }));
        imageList.value = [...newVal];
      } else {
        internalFileList.value = [];
        imageList.value = [];
      }
      showUploadButton.value = internalFileList.value.length < 5;
    }, {
      immediate: true,
      deep: true
    });
    const fileList = ref([]);
    let image_list = ref([]);
    const close = () => {
      dialogVisible.value = false;
    };
    const handleClose = done => {
      close();
      done();
    };
    const handleExceed = () => {
      ElMessage.warning('最多上传5个文件');
    };
    const beforeUpload = file => {
      const isValidType = isImage(file) || isVideo(file);
      const isValidSize = file.size <= 5 * 1024 * 1024;
      if (!isValidType) {
        ElMessage.error('仅支持图片或视频格式！');
        return false;
      }
      if (!isValidSize) {
        ElMessage.error(`文件 ${file.name} 超过5MB限制`);
        return false;
      }
      return true;
    };

    // 生成对象URL 视频预览问题
    const getObjectURL = file => {
      if (file) {
        if (file.status === 'success') return file.url;
        return URL.createObjectURL(file);
      }
    };
    const isImage = file => {
      var _file$type, _file$raw;
      return (file === null || file === void 0 || (_file$type = file.type) === null || _file$type === void 0 ? void 0 : _file$type.startsWith('image/')) || ((_file$raw = file.raw) === null || _file$raw === void 0 || (_file$raw = _file$raw.type) === null || _file$raw === void 0 ? void 0 : _file$raw.startsWith('image/'));
    };
    const isVideo = file => {
      var _file$type2, _file$raw2;
      return (file === null || file === void 0 || (_file$type2 = file.type) === null || _file$type2 === void 0 ? void 0 : _file$type2.startsWith('video/')) || ((_file$raw2 = file.raw) === null || _file$raw2 === void 0 || (_file$raw2 = _file$raw2.type) === null || _file$raw2 === void 0 ? void 0 : _file$raw2.startsWith('video/'));
    };
    const handlePreview = file => {
      const matchedFile = internalFileList.value.find(item => item.uid === file.uid);
      let url = matchedFile === null || matchedFile === void 0 ? void 0 : matchedFile.url;
      if (!url) {
        url = file.url || getObjectURL(file.raw);
      }
      if (isImage(file)) {
        window.open(url, '_blank');
      } else if (isVideo(file)) {
        // 视频预览逻辑
        const videoWindow = window.open('', '_blank');
        videoWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
            <title>视频预览</title>
        </head>
        <body style="margin:0;padding:0;background:#000;">
            <video controls autoplay style="width:100%;height:100%;">
            <source src="${url}" type="video/mp4">
            您的浏览器不支持视频标签
            </video>
        </body>
        </html>
    `);
      }
    };
    const handleRemove = file => {
      const matchFn = f => f.uid === file.uid || f.url === file.url;
      const index = internalFileList.value.findIndex(matchFn);
      if (index !== -1) {
        internalFileList.value.splice(index, 1);
      }
      const index2 = imageList.value.findIndex(matchFn);
      if (index2 !== -1) {
        imageList.value.splice(index2, 1);
      }
      showUploadButton.value = internalFileList.value.length < 5;
      sumbitShow.value = true;
      emit('update:fileList', [...internalFileList.value]);
    };
    const onUploadSuccess = async param => {
      const {
        code,
        data,
        msg
      } = await fileUpload(param.file, {
        folderName: 'FinishedProductImage'
      });
      if (code != 200) {
        return proxy.$message({
          type: 'error',
          message: msg
        });
      }
      const {
        url
      } = data;
      function getFileExtension(url) {
        const fileName = url.split('/').pop();
        const dotIndex = fileName.lastIndexOf('.');
        return dotIndex !== -1 ? fileName.substring(dotIndex + 1).toLowerCase() : '';
      }
      const extension = getFileExtension(url);
      if (extension) {
        const newItem = {
          img_url: '',
          video_url: ''
        };
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'];
        const videoExtensions = ['mp4', 'mov', 'avi', 'mkv', 'flv', 'wmv'];
        if (imageExtensions.includes(extension)) {
          newItem.img_url = url;
        } else if (videoExtensions.includes(extension)) {
          newItem.video_url = url;
        } else {
          console.log('不支持的文件类型:', extension);
        }
        image_list.value.push(newItem);
      }
      internalFileList.value.push({
        uid: param.file.uid,
        name: param.file.name,
        status: 'success',
        url: data.url,
        type: isImage(param.file) ? 'image' : param.file.type
      });
      showUploadButton.value = internalFileList.value.length < 5;
      sumbitShow.value = true;
    };
    const submit = () => {
      const convertedImgList = internalFileList.value.map(item => {
        var _item$raw;
        const isImage = (item === null || item === void 0 ? void 0 : item.type.includes('image')) || ((_item$raw = item.raw) === null || _item$raw === void 0 ? void 0 : _item$raw.type.includes('image'));
        return {
          img_url: isImage ? item.url : '',
          video_url: isImage ? '' : item.url
        };
      });
      const combinedList = [...convertedImgList];
      if (combinedList.length === 0) {
        ElMessage.warning('请至少上传一个文件');
        return;
      }
      proxy.$http.post('/port/orders/up_delivery_voucher', {
        id: props.currentRow.order_id,
        img_list: combinedList
      }).then(res => {
        switch (res.code) {
          case '200':
            ElMessage.success('上传成功');
            sumbitShow.value = false;
            close();
            break;
          case '202':
            ElMessage.error('上传视频中包含不合规视频，请检查');
            break;
          case '204':
            ElMessage.error('上传图片中包含不合规图片，请检查');
            break;
          default:
            ElMessage.error('上传失败');
        }
      });
      // close();
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_main = _resolveComponent("el-main");
      return _openBlock(), _createBlock(_component_el_main, {
        class: "summary-box",
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => dialogVisible.value = $event),
        title: "上传照片/视频：",
        width: "500px",
        "before-close": handleClose
      }, {
        default: _withCtx(() => [_createVNode(_component_el_upload, {
          "file-list": props.fileList,
          "onUpdate:fileList": _cache[0] || (_cache[0] = $event => props.fileList = $event),
          multiple: "",
          limit: 5,
          "on-exceed": handleExceed,
          class: _normalizeClass({
            'hide-upload': !showUploadButton.value
          }),
          "before-upload": beforeUpload,
          accept: "image/*,video/*",
          "list-type": "picture-card",
          "http-request": onUploadSuccess
        }, {
          file: _withCtx(({
            file
          }) => [_createElementVNode("div", _hoisted_1, [isImage(file) ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: file.url || getObjectURL(file.raw),
            class: "upload-file-preview"
          }, null, 8, _hoisted_2)) : isVideo(file) ? (_openBlock(), _createElementBlock("video", _hoisted_3, [_createElementVNode("source", {
            src: file.url || getObjectURL(file.raw),
            type: file.type
          }, null, 8, _hoisted_4), _cache[2] || (_cache[2] = _createTextVNode(" 您的浏览器不支持视频播放 "))])) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_5, [_createElementVNode("span", {
            class: "el-upload-list__item-preview",
            onClick: $event => handlePreview(file)
          }, [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(ZoomIn))]),
            _: 1
          })], 8, _hoisted_6), _createElementVNode("span", {
            class: "el-upload-list__item-delete",
            onClick: $event => handleRemove(file)
          }, [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Delete))]),
            _: 1
          })], 8, _hoisted_7)]), _createElementVNode("div", _hoisted_8, _toDisplayString(isImage(file) ? '图片' : '视频'), 1)])]),
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Plus))]),
            _: 1
          })]),
          _: 1
        }, 8, ["file-list", "class"]), _createElementVNode("div", _hoisted_9, [_cache[4] || (_cache[4] = _createTextVNode("每次5MB以内；限5张 ")), sumbitShow.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          onClick: submit,
          style: {
            "margin-left": "20px"
          }
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("保存")])),
          _: 1
        })) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};